<template>
  <span class="automation-result-action-icons flex-row automation-icons gap-xs" v-if="isProcessed">
    <a-tooltip v-if="executedAction">
      <template #title>
        Actie uitgevoerd
      </template>
      <div class="icon-wrapper">
        <DatabaseSyncIcon class="icon-size-md"/>
      </div>
    </a-tooltip>
    <a-tooltip v-if="hasSentEmail">
      <template #title>
        Email verzonden
      </template>
      <div class="icon-wrapper">
        <EmailFastIcon class="icon-size-md"/>
      </div>
    </a-tooltip>
    <a-tooltip v-else-if="failedToSendEmail">
      <template #title>
        Email niet verzonden
      </template>
      <div class="icon-wrapper">
        <EmailRemoveIcon class="icon-size-md"/>
      </div>
    </a-tooltip>
    <a-tooltip v-if="createdSignal">
      <template #title>
        Signaal aangemaakt
      </template>
      <div class="icon-wrapper">
        <BellIcon class="icon-size-md"/>
      </div>
    </a-tooltip>
    <a-tooltip v-if="createdTask">
      <template #title>
        Taak aangemaakt
      </template>
      <div class="icon-wrapper">
        <CheckboxOutlineIcon class="icon-size-md"/>
      </div>
    </a-tooltip>
  </span>
</template>

<script>
import AutomationIconComponent from '../../AutomationIconComponent.vue'

export default {
  name: 'AutomationResultActionCell',
  props: {
    row: {
      type: Object,
      required: true
    }
  },
  components: {
    AutomationIconComponent
  },
  computed: {
    executedAction () {
      return this.row.execute_action
    },
    hasSentEmail () {
      return this.row.send_email && this.row.has_send_email
    },
    failedToSendEmail () {
      return this.row.send_email && !this.row.has_send_email
    },
    createdSignal () {
      return this.row.create_signal
    },
    createdTask () {
      return this.row.create_task
    },
    needsVerification () {
      return this.row.needs_verification
    },
    isProcessed () {
      return this.processed_at !== null
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@/_default.scss';

.automation-result-action-icons {
  .icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
